module.exports = __webpack_public_path__ + "img/model-front.c3db1a22.svg";